import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { blueGrey, red } from '@mui/material/colors';

let theme = createTheme({
  palette: {
    primary: {
      main: '#324899',
    },
    secondary: {
      main: '#327c99',
    },
    error: {
      main: red.A400,
    },

    header: {
      main: blueGrey[700],
      contrastText: '#FFFFFF',
    },
    white_button: {
      main: '#FFFFFF',
      contrastText: blueGrey[700],
    },
    black_button: {
      main: '#000000',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F3F6F9', // firstColor
    },
  },

  typography: {
    fontFamily: [
      'Google Sans',
      'sans-serif',
      'Roboto',
    ].join(','),
    allVariants: {
        fontFamily: [
            'Google Sans',
            'sans-serif',
            'Roboto',
        ].join(','),
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;